export default __webpack_public_path__ + "static/4-85134733470c1a02d563bc722882ed64.png";